export default "__VITE_ASSET__BPOvDgO8__"